/**
 * wineRegionAliases — Fase 7.3
 *
 * Mappa i nomi di ZONE VINICOLE presenti nell'anagrafica Casa Orterie (nomi
 * commerciali italiani/legacy: "Champagne", "Loira", "Rodano", ecc.) alle
 * corrispondenti REGIONI amministrative di Natural Earth admin-1 (che invece
 * usano nomi ufficiali: "Grand Est", "Pays de la Loire", ecc.).
 *
 * Chiave: nome zona come appare in `map_zones.region` (case/accenti-insensitive).
 * Valore: { country_en, admin1: [uno o più nomi feature.properties.region NE] }
 *
 * Se una zona non è in questo mapping E non matcha direttamente per nome col
 * dataset admin-1, NON viene renderizzata (evitiamo i vecchi poligoni "a
 * scatola" AI) — rimane comunque nella tendina laterale.
 */
const A = {
    // === FRANCIA ===
    "champagne": { c: "France", a: ["Grand Est"] },
    "bourgogne": { c: "France", a: ["Bourgogne-Franche-Comté"] },
    "borgogna": { c: "France", a: ["Bourgogne-Franche-Comté"] },
    "bordeaux": { c: "France", a: ["Nouvelle-Aquitaine"] },
    "loira": { c: "France", a: ["Pays de la Loire", "Centre-Val de Loire"] },
    "valle della loira": { c: "France", a: ["Pays de la Loire", "Centre-Val de Loire"] },
    "rodano": { c: "France", a: ["Auvergne-Rhône-Alpes"] },
    "rhône": { c: "France", a: ["Auvergne-Rhône-Alpes"] },
    "valle del rodano": { c: "France", a: ["Auvergne-Rhône-Alpes"] },
    "alsace": { c: "France", a: ["Grand Est"] },
    "alsazia": { c: "France", a: ["Grand Est"] },
    "languedoc-roussillon": { c: "France", a: ["Occitanie"] },
    "linguadoca": { c: "France", a: ["Occitanie"] },
    "linguadoca-rossiglione": { c: "France", a: ["Occitanie"] },
    "roussillon": { c: "France", a: ["Occitanie"] },
    "rossiglione": { c: "France", a: ["Occitanie"] },
    "rossiglione (francia)": { c: "France", a: ["Occitanie"] },
    "provence": { c: "France", a: ["Provence-Alpes-Côte d'Azur"] },
    "provenza": { c: "France", a: ["Provence-Alpes-Côte d'Azur"] },
    "cognac": { c: "France", a: ["Nouvelle-Aquitaine"] },
    "armagnac": { c: "France", a: ["Occitanie"] },
    "savoia": { c: "France", a: ["Auvergne-Rhône-Alpes"] },
    "corsica": { c: "France", a: ["Corse"] },
    "jura": { c: "France", a: ["Bourgogne-Franche-Comté"] },
    "normandia": { c: "France", a: ["Normandie"] },

    // === SPAGNA ===
    "rioja": { c: "Spain", a: ["La Rioja"] },
    "ribera del duero": { c: "Spain", a: ["Castilla y León"] },
    "priorat": { c: "Spain", a: ["Cataluña"] },
    "penedès": { c: "Spain", a: ["Cataluña"] },
    "cataluña": { c: "Spain", a: ["Cataluña"] },
    "catalogna": { c: "Spain", a: ["Cataluña"] },
    "andalucía": { c: "Spain", a: ["Andalucía"] },
    "andalusia": { c: "Spain", a: ["Andalucía"] },
    "jerez": { c: "Spain", a: ["Andalucía"] },
    "castiglia": { c: "Spain", a: ["Castilla y León", "Castilla-La Mancha"] },

    // === GERMANIA ===
    "mosella": { c: "Germany", a: ["Rheinland-Pfalz"] },
    "mosel": { c: "Germany", a: ["Rheinland-Pfalz"] },
    "reno": { c: "Germany", a: ["Rheinland-Pfalz"] },
    "rheinhessen": { c: "Germany", a: ["Rheinland-Pfalz"] },
    "pfalz": { c: "Germany", a: ["Rheinland-Pfalz"] },
    "baden": { c: "Germany", a: ["Baden-Württemberg"] },
    "franken": { c: "Germany", a: ["Bayern"] },
    "franconia": { c: "Germany", a: ["Bayern"] },
    "württemberg": { c: "Germany", a: ["Baden-Württemberg"] },

    // === PORTOGALLO ===
    "douro": { c: "Portugal", a: ["Porto"] },
    "porto": { c: "Portugal", a: ["Porto"] },
    "alentejo": { c: "Portugal", a: ["Évora", "Beja", "Portalegre"] },
    "vinho verde": { c: "Portugal", a: ["Braga", "Viana do Castelo", "Porto"] },

    // === AUSTRIA / UNGHERIA ===
    "wachau": { c: "Austria", a: ["Niederösterreich"] },
    "burgenland": { c: "Austria", a: ["Burgenland"] },
    "tokaj": { c: "Hungary", a: ["Borsod-Abaúj-Zemplén"] },

    // === USA ===
    "napa valley": { c: "United States of America", a: ["California"] },
    "napa": { c: "United States of America", a: ["California"] },
    "sonoma": { c: "United States of America", a: ["California"] },
    "california": { c: "United States of America", a: ["California"] },
    "oregon": { c: "United States of America", a: ["Oregon"] },
    "washington": { c: "United States of America", a: ["Washington"] },

    // === SUD AMERICA ===
    "mendoza": { c: "Argentina", a: ["Mendoza"] },
    "colchagua": { c: "Chile", a: ["Libertador General Bernardo O'Higgins"] },
    "maipo": { c: "Chile", a: ["Metropolitana de Santiago"] },
    "casablanca": { c: "Chile", a: ["Valparaíso"] },

    // === SUD AFRICA / OCEANIA ===
    "stellenbosch": { c: "South Africa", a: ["Western Cape"] },
    "western cape": { c: "South Africa", a: ["Western Cape"] },
    "barossa": { c: "Australia", a: ["South Australia"] },
    "mclaren vale": { c: "Australia", a: ["South Australia"] },
    "margaret river": { c: "Australia", a: ["Western Australia"] },
    "marlborough": { c: "New Zealand", a: ["Marlborough"] },
    "central otago": { c: "New Zealand", a: ["Otago"] },

    // === MEDITERRANEO / MED. ORIENTALE ===
    "santorini": { c: "Greece", a: ["Attica"] },
    "libano": { c: "Lebanon", a: [] },
    "beqaa": { c: "Lebanon", a: [] },
};

function _n(s) {
    return (s || "")
        .toLowerCase()
        .normalize("NFD")
        .replace(/\p{Diacritic}/gu, "")
        .trim();
}

/**
 * Ritorna le region names admin-1 corrispondenti a una zona vinicola DB.
 * @param {string} zoneName - es "Champagne", "Bourgogne", "Loira"
 * @param {string} countryEn - paese in inglese (opzionale, per disambiguare)
 * @returns {string[]} - nomi delle feature admin-1 corrispondenti; [] se ignoto
 */
export function aliasAdmin1(zoneName, countryEn) {
    const key = _n(zoneName);
    const hit = A[key];
    if (!hit) {
        // Fallback: torna il nome stesso — matchpotrebbe funzionare direttamente
        // (regioni italiane openpolis + regioni estere che coincidono con NE).
        return [zoneName];
    }
    if (countryEn && _n(hit.c) !== _n(countryEn)) return [];
    return hit.a;
}

export default A;
